<template>
	<transition name="fade">
		<div class="alert" :class="type + ' ' + size" v-if="showError">
			<div class="alert-container">
			  <div class="flex">
			    <div class="flex-shrink-0 self-center">
			      <svg viewBox="0 0 20 20" fill="currentColor" v-if="type == 'success'">
				    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
				  </svg>
				  <svg viewBox="0 0 20 20" fill="currentColor" v-if="type == 'error'">
			        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
			      </svg>
			    </div>
			    <div class="alert-text-container">
			      <p class="alert-text pb-0 m-0">
			        <slot></slot>
			      </p>
			      <div class="close-btn-container">
					  <div class="-mx-1.5 -my-1.5">
					    <button @click="close">
					      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
					        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
					      </svg>
					    </button>
					  </div>
					</div>
			    </div>
			  </div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'feedback.alert',
		props: {
			type: {
				type: String,
				default: 'success'
			},
			show: {
				type: Boolean,
				default: false,
			},
			fadeable: {
				type: Boolean,
				default: false,
			},
			size: {
				type: String,
				default: 'sm'
			}
		},
		data() {
			return {
				showError: false,
			}
		},
		mounted() {
			this.showError = this.show;
		},
		watch: {
			show: function (newVal, oldVal) {
				const self = this;

				this.showError 	= newVal;

				if(newVal && this.fadeable) {
					setTimeout(function() {
						self.showError = false;

						self.$emit('close', true);
					}, 7000)
				}
			}
		},
		methods: {
			close() {
				this.showError = false;

				this.$emit('close', true);
			}
		}
	}
</script>